import QuestionObj from "../Models/QuestionObj";

const IT_QSet = [
  new QuestionObj({
    questionSet: {
      English:
        "How capable is your commerce solution in adapting to current and future business needs?",
    },
    answerSet: {
      English: [
        "Not very capable. Changes take significant time and resources.",
        "Our solution is capable of meeting current needs, but we do have concerns about our solution being able to keep pace with industry and business changes",
        "Very capable. We have a flexible, scalable solution that gives us the ability to meet current and future needs.",
      ],
    },
    custVals: [25, 66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "Is data connected across your organization in a way that allows for actionable, real-time insights to improve commerce outcomes?",
    },
    answerSet: {
      English: [
        "No, data is siloed within individual applications and technologies and unusable in other parts of the business",
        "Somewhat, we can aggregate customer and business data across our products but extracting meaningful insights is a manual, labor intensive process",
        "Yes, our commerce platform can effectively utilize customer and business data from across the organization"
      ],
    },
    custVals: [25,66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "Is your commerce solution flexible enough to deploy using full stack capabilities, go fully headless, or take a hybrid approach?",
    },

    answerSet: {
      English: [
        "No, our solution lacks the flexibility to choose from various deployment options",
        "Somewhat, our solution gives us some flexibility to go headless or use the packaged front end, but we don’t have a hybrid option",
        "Yes, our solution allows for multiple options for deployment",
        "Achieve your commerce goals and meet any business need with a flexible commerce solution.",
      ],
    },
    custVals: [25, 50, 75, 100],
  }),
  new QuestionObj({
    questionSet: {
      English: "Are you able to empower developers to innovate using flexible frameworks?",
    },
    answerSet: {
      English: [
        "No, our solution requires heavy reliance on our technical teams for basic operations, leaving little opportunity to innovate",
        "Somewhat, our business users can do a lot of the day-to-day, but our technical teams still spend a lot of time maintaining the core solution",
        "Yes, our commerce solution utilizes intuitive business user tooling and modern frameworks, so our developers can accelerate delivery with an eye on innovation."
      ],
    },
    custVals: [25,66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "Is your commerce solution supported by cost-effective architecture?",
    },
    answerSet: {
      English: [
        "No, while our commerce solution supported past business goals, it can no longer keep up with current business requirements",
        "Somewhat. We’re able to adapt our current solution to address evolving business needs, but changes are costly and time consuming",
        "Yes, our commerce solution is built with adaptability for current and future business goals in mind",
      ],
    },
    custVals: [25, 66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "How easily can your commerce solution integrate with other applications to achieve all of your desired capabilities across the customer lifecycle?",
    },
    answerSet: {
      English: [
        "Not easily. Integrating applications with our commerce solution requires significant resources",
        "It's a bit mixed. We can easily integrate with some 3rd party applications via a marketplace, but integration into other 1st or 3rd party applications can prove difficult",
        "Easily. We’re able to leverage robust native integrations and drag-and-drop mapping and integrating capabilities to reduce time and costs of integrating into our commerce application",
      ],
    },
    custVals: [25, 66, 100],
  }),
  new QuestionObj({
    questionSet: {
      English:
        "Is your commerce solution supported by cost-effective architecture?",
      German: "German Q1",
      French: "French Q1",
      Russian: "Russian Q1",
      Turkish: "Turkish Q1",
      Italian: "Italian Q1",
      Spanish: "Spanish Q1",
      PortugueseBR: "PortugueseBR Q1",
      SpanishLAD: "SpanishLAD Q1",
    },
    answerSet: {
      English: [
        "No, we had large costs associated with implementation and continue to for maintenance",
        "Somewhat, we had large implementation costs, but we can maintain the website as long as we don’t frequently update",
        "Yes, we were able to implement and maintain our site with low costs",
        "Yes, we were able to implement, maintain, and continue to customize our site with low costs",
      ],
      German: ["German A ", "German B", "German C", "German D "],
      French: ["French A", "French B", "French C", "French D"],
      Russian: ["Russian A", "Russian B", "Russian C", "Russian D"],
      Turkish: ["Turkish A", "Turkish B", "Turkish C", "Turkish D"],
      Italian: ["Italian A", "Italian B", "Italian C", "Italian D"],
      Spanish: ["Spanish A", "Spanish B", "Spanish C", "Spanish D"],
      PortugueseBR: [
        "PortugueseBR A",
        "PortugueseBR B",
        "PortugueseBR C",
        "PortugueseBR C ",
      ],
      SpanishLAD: [
        "SpanishLAD A",
        "SpanishLAD B. ",
        "SpanishLAD C",
        "SpanishLAD D",
      ],
    },
    custVals: [25, 50, 75, 100],
  })
];

export default IT_QSet;
